import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from "./ter-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import tclocal from "./ter-consts-local-lib";
import { _getFromLibMaterijalLimSingleParam, _getParamsFromLibMaterijalLimParams } from "./ter-materijal-utils";
import { AND, PI, ROUND, ROUNDDOWN, SIN, XIF } from "../utils/excel-functions-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM } from "./ter-protobomp-utils";
import { js_utils } from "../utils/frfr-js-utils";


// PKZ nema pods_input
// export const derDraftel_terkk_pkz_pripremi_pods_input_inherited_za_draftel = (virtel_m) => {


//
export const _derivat_terkk_pkz_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  let pkz_materijal_lim = null;
  //
  if (cparams_combined && cparams_combined.terkk_materijal_ident) { // validate cparams TODO
    // By cparmas
    if (js_utils.is_string_not_empty(cparams_combined.terkk_materijal_ident.pkz_materijal_lim_default)) { // validate cparams TODO
      // By cparmas
      pkz_materijal_lim = cparams_combined.terkk_materijal_ident.pkz_materijal_lim_default;
    }
  }
  //
  return {
    pkz_materijal_lim,
  };
};


//
export const _derivat_protivkisnazaluzina_izracunaj_broj_delova = (kolicina, pkz_sirinasvetlogotvora, pkz_a, pkz_b) => {
  let pkz_brojdelova = 0;
  /*
  const C8 = pkz_sirinasvetlogotvora;
  const F8 = kolicina;
  if (kolicina > 0 && pkz_sirinasvetlogotvora > 0) {
    pkz_brojdelova = XIF(F8 === "", "", XIF(C8 >= 1250, 2, 1))
  }
  */
  // NJ: ovde za broj delova sa uradio prepravku u formuli: Broj delova može imati vrednost 1 i 2. Proračunava se na osnovu sledeće formule.
  // IF OR ( AND(A<=1250;B<=2500) ; AND(A<=2500;B<=1250) ) THEN 1 ELSE 2 // Izmena 13.11.2024
  if ((pkz_a <= 1250 && pkz_b <= 2500) || (pkz_a <= 2500 && pkz_b <= 1250)) {
    pkz_brojdelova = 1;
  } else {
    pkz_brojdelova = 2;
  }
  return pkz_brojdelova;
};


// izracunavanje za wiz step 2
export const _derivat_terkk_pkz_izracunaj_abcde = (state, pods_input) => {
  //
  // const {} = pods_input; // nema pods_input
  const {
    pkz_sirinasvetlogotvora,
    pkz_visinasvetlogotvora,
  } = state;

  // A Izračunava se po formuli $pkz_sirinasvetlogotvora+36
  const pkz_a = pkz_sirinasvetlogotvora + 36;

  // B Izračunava se po formuli $pkz_visinasvetlogotvora+36
  const pkz_b = pkz_visinasvetlogotvora + 36;

  // Broj redova Izračunava se po formuli
  // IF ROUND($pkz_visinasvetlogotvora/250;0)<2 THEN 2 ELSE ROUND($pkz_visinasvetlogotvora/250;0)
  let pkz_brojredova = ROUND((pkz_visinasvetlogotvora / 250), 0);
  if (pkz_brojredova < 2) {
    pkz_brojredova = 2;
  }

  // C Izračunava se po sledećoj formuli
  // (B/Broj redova)-20
  const pkz_c = (pkz_b / pkz_brojredova) - 20;

  // D Izračunava se po sledećoj formuli
  // ((C)(SIN(90PI()/180)/SIN(45*PI()/180)))
  const pkz_d = (pkz_c * (SIN((90 * PI()) / 180) / SIN((45 * PI()) / 180)));

  // E Izračunava se po sledećoj formuli
  // (B-20)/Broj redova)
  // B-22
  const pkz_e = pkz_b - 22;

  // 
  const pkz_brojdelova = _derivat_protivkisnazaluzina_izracunaj_broj_delova(null, null, pkz_a, pkz_b);

  //
  return {
    // NJ 2024-12-03: Možeš da zaokružiš funkcijom ROUND na 1 decimalu. Pored sastavnice, potrebno je zaokružiti i parametre od A do E.
    pkz_a: ROUND(pkz_a, 1),
    pkz_b: ROUND(pkz_b, 1),
    pkz_c: ROUND(pkz_c, 1),
    pkz_d: ROUND(pkz_d, 1),
    pkz_e: ROUND(pkz_e, 1),
    pkz_brojredova,
    pkz_brojdelova,
  };
};


//
export const _derivat_terkk_pkz_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    pkz_materijal_lim,
    pkz_visinasvetlogotvora,
    pkz_sirinasvetlogotvora,
    pkz_brojredova,
    pkz_brojdelova,
    pkz_a,
    pkz_b,
    pkz_c,
    pkz_d,
    pkz_e,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$pkz/SKLOP_PKZ') {
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora //13.11.2024 Izmena
      Količina: $kolicina
      Jedinica mere: kom
      Operacija 1:Sklapanje
      Radni centar: Finalizacija
      */
      item.distinction_key = "terkk$PKZ/SKLOP_C"; // DIRTY
      item.tip = "C"; // DIRTY
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora; //
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "GRCFIN"; // DIRTY
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
      item.pkz_brojdelova = pkz_brojdelova; // DIRTY
      item.pkz_brojredova = pkz_brojredova; // DIRTY
    }
    //
    //
    if (family === 'terkk$pkz/P1') { // 2. P1
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora?-P1"
      Količina: 1
      Dim1: D
      Dim2: A
      Povrsina: razvijena1*razvijena2
      razvijena1: D+52,6
      razvijena2: A+38,1
      CNC crtež: "P01-08-C-"$pkz_a "X" $pkz_b"-P1"
      Operacija 1: sečenje
      Radni centar1: Probijačica S4
      Operacija 2: Savijanje
      Radni centar 2: Savijačica P4
      Ident materijala: LB00000J-LIM POCINKOVANI 1.50
      */
      item.distinction_key = "terkk$PKZ/C_P1"; // DIRTY
      item.tip = "C-P1"; // DIRTY
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora + "-P1"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = pkz_d; // DIRTY
      item.dimenzija2 = pkz_a; // DIRTY
      item.razvijenamera1 = pkz_d + 52.6; // DIRTY
      item.razvijenamera2 = pkz_a + 38.1; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBS4"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCSAVP4"; // DIRTY
      _cnc = "P01-08-C-" + pkz_sirinasvetlogotvora + "X" + pkz_visinasvetlogotvora + "-P1";
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
    }
    //
    if (family === 'terkk$pkz/P2') { // 3. P2
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora?-P2"
      Količina: pkz_brojredova-1
      D1:D-9
      Dim1: D1
      Dim2: A-3
      Povrsina: razvijena1*razvijena2
      razvijena1: D+52,6
      razvijena2: A+32,1
      CNC crtež: "P01-08-C-"$pkz_a "X" $pkz_b"-P2"
      Operacija 1: sečenje
      Radni centar1: Probijačica S4
      Operacija 2: Savijanje
      Radni centar 2: Savijačica P4
      Ident materijala: LB00000J-LIM POCINKOVANI 1.50
      */
      item.distinction_key = "terkk$PKZ/C_P2"; // DIRTY
      item.tip = "C-P2"; // DIRTY
      const D1 = pkz_d - 9;
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora + "-P2"; // DIRTY
      item.kolicina = pkz_brojredova - 1; // DIRTY
      item.dimenzija1 = D1; // DIRTY
      item.dimenzija2 = pkz_a - 3; // DIRTY
      item.razvijenamera1 = pkz_d + 52.6; // DIRTY
      item.razvijenamera2 = pkz_a + 38.1; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBS4"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCSAVP4"; // DIRTY
      _cnc = "P01-08-C-" + pkz_sirinasvetlogotvora + "X" + pkz_visinasvetlogotvora + "-P2";
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
    }
    //
    if (family === 'terkk$pkz/P3') { // 4. p3
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora"-P3"
      Količina: 1
      Dim1: E
      Dim2: C
      Povrsina: razvijena1*razvijena2
      razvijena1: E
      razvijena2: C+17,5
      CNC crtež: "P01-08-C-"$pkz_a "X" $pkz_b"-P3"
      Operacija 1: sečenje
      Radni centar1: Probijačica S4
      Operacija 2: Savijanje
      Radni centar 2: Savijačica P4
      Ident materijala: LB00000J-LIM POCINKOVANI 1.50
      */
      item.distinction_key = "terkk$PKZ/C_P3"; // DIRTY
      item.tip = "C-P3"; // DIRTY
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora + "-P3"; // DIRTY
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = pkz_e; // DIRTY
      item.dimenzija2 = pkz_c; // DIRTY
      item.razvijenamera1 = pkz_e; // DIRTY
      item.razvijenamera2 = pkz_c + 17.5; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBS4"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCSAVP4"; // DIRTY
      _cnc = "P01-08-C-" + pkz_sirinasvetlogotvora + "X" + pkz_visinasvetlogotvora + "-P3";
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
    }
    //
    if (family === 'terkk$pkz/P4') { // 5. P4
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora"-P4"
      Količina: 1
      Dim1: E
      Dim2: C
      Povrsina: razvijena1*razvijena2
      razvijena1: E
      razvijena2: C+17,5
      CNC crtež: "P01-08-C-"$pkz_a "X" $pkz_b"-P4"
      Operacija 1: sečenje
      Radni centar1: Probijačica S4
      Operacija 2: Savijanje
      Radni centar 2: Savijačica P4
      Ident materijala: LB00000J-LIM POCINKOVANI 1.50
      */
      item.distinction_key = "terkk$PKZ/C_P4"; // DIRTY
      item.tip = "C-P4"; // DIRTY
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora + "-P4"; // DIRTY
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = pkz_e; // DIRTY
      item.dimenzija2 = pkz_c; // DIRTY
      item.razvijenamera1 = pkz_e; // DIRTY
      item.razvijenamera2 = pkz_c + 17.5; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBS4"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCSAVP4"; // DIRTY
      _cnc = "P01-08-C-" + pkz_sirinasvetlogotvora + "X" + pkz_visinasvetlogotvora + "-P4";
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
    }
    //
    if (family === 'terkk$pkz/P5') { // 6. P5
      /*
      Naziv: "PROTIV KISNA ZALUZINA "$pkz_visinasvetlogotvora "X" $pkz_sirinasvetlogotvora"-P5"
      Količina: 1
      Dim1: A
      Dim2: B
      Povrsina: razvijena1*razvijena2
      razvijena1: A
      razvijena2: B
      CNC crtež: "P01-08-C-"$pkz_a "X" $pkz_b"-P5"
      Operacija 1: sečenje
      Radni centar1: Probijačica Amada
      Operacija 2: null
      Radni centar 2: null
      Ident materijala: LB00000J-LIM POCINKOVANI 1.50
      */
      item.distinction_key = "terkk$PKZ/C_P5"; // DIRTY
      item.tip = "C-P5"; // DIRTY
      _naziv = "PROTIV KISNA ZALUZINA " + pkz_sirinasvetlogotvora + "x" + pkz_visinasvetlogotvora + "-P5"; // DIRTY
      // item.kolicina = 1; // DIRTY
      // item.dimenzija1 = pkz_a; // DIRTY
      item.dimenzija2 = pkz_b; // DIRTY
      // item.razvijenamera1 = pkz_a; // DIRTY
      item.razvijenamera2 = pkz_b; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = null; // DIRTY
      item.rc2 = null; // DIRTY
      _cnc = "P01-08-C-" + pkz_sirinasvetlogotvora + "X" + pkz_visinasvetlogotvora + "-P5";
      item.pkz_sirinasvetlogotvora = pkz_sirinasvetlogotvora; // DIRTY
      item.pkz_visinasvetlogotvora = pkz_visinasvetlogotvora; // DIRTY
      item.pkz_brojdelova = pkz_brojdelova; // DIRTY
    }

    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_pkz_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  // const {} = pods_input; // nema pods_input
  const {
    tip,
    pkz_sirinasvetlogotvora,
    pkz_visinasvetlogotvora,
    //
    pkz_materijal_lim,
    pkz_brojredova,
    pkz_brojdelova,
    pkz_a,
    pkz_b,
    pkz_c,
    pkz_d,
    pkz_e,
    kolicina,
  } = state;

  // TODO
  const protobomp_superdata = {
    pkz_materijal_lim,
    pkz_visinasvetlogotvora,
    pkz_sirinasvetlogotvora,
    pkz_brojredova,
    pkz_brojdelova,
    pkz_a,
    pkz_b,
    pkz_c,
    pkz_d,
    pkz_e,
  };

  const B8 = tip;
  const C8 = pkz_sirinasvetlogotvora;
  const D8 = pkz_visinasvetlogotvora;
  const F8 = kolicina;

  // Broj Crteža: =IF(F8="","",IF(AND(B8="STARA",C8<1250),"P01-08-A","P01-08-B"))
  const broj_crteza = XIF(F8 === "", "", XIF(AND(B8 === "STARA", C8 < 1250), "P01-08-A", "P01-08-B"));

  // Ident: =IF(F8="","",IF(AND(B8="STARA",C8<1250),"P01-08-A"&"-"&C8&"x"&D8,"P01-08-B"&"-"&C8/2&"x"&D8))
  const ident = XIF(F8 === "", "", XIF(AND(B8 === "STARA", C8 < 1250), "P01-08-A" + "-" + C8 + "x" + D8, "P01-08-B" + "-" + C8 / 2 + "x" + D8));

  // Naziv: =IF(F8="","","PROTIV KIŠNA ZAŠTITA "&B8&" "&C8&"x"&D8)
  const naziv = XIF(F8 === "", "", "PROTIV KIŠNA ZAŠTITA " + B8 + " " + C8 + "x" + D8);

  // A [mm] : =IF(F8="","",C8+36)
  const a = XIF(F8 === "", "", C8 + 36);

  // B [mm] : =IF(F8="","",D8+36)
  const b = XIF(F8 === "", "", D8 + 36);

  // Broj Redova =IF(F8="","",IF(ROUND(D8/250,0)<2,2,ROUND(D8/250,0)))
  const broj_redova = XIF(F8 === "", "", XIF(ROUND(D8 / 250, 0) < 2, 2, ROUND(D8 / 250, 0)))

  // E [mm] : =IF(F8="","",(D8+36-20)/L15)
  const L15 = broj_redova;
  const e = XIF(F8 === "", "", (D8 + 36 - 20) / L15)

  // D [mm] : =IF(F8="","",(SIN(80*PI()/180)*K15)/SIN(57.54*PI()/180))
  const K15 = e;
  const d = XIF(F8 === "", "", (SIN(80 * PI() / 180) * K15) / SIN(57.54 * PI() / 180))

  // C [mm] : =IF(F8="","",(SIN(42.46*PI()/180)*J15))
  const J15 = d;
  const c = XIF(F8 === "", "", (SIN(42.46 * PI() / 180) * J15));

  /*
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(termaterijal);
  const _tipmetalalima = _mat_params.naziv_materijala;
  const F7 = _tipmetalalima;
  */

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$pkz"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_pkz_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = { // /. Odnosi se na sklop poluproizvoda:
    ..._sklop_uzor,
    pbnode_family: 'terkk$pkz/SKLOP_PKZ',
    naziv: '* SKLOP PKZ',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_PKZ');
  const { created_tempkey: sklop_pkz } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //

  //
  // ??? DA LI SAMO JEDAN IMA?
  if (true) {
    // *1
    if (true) {
      const item = {
        tempkey: 1,
        // tip: "VERTIKALNI_NOSAC_LEVI",
        naziv,
        cnccrtez: broj_crteza,
        ident,
        naziv,
        a,
        b,
        c,
        d,
        e,
        pkz_brojredova: broj_redova,

        pbnode_family: 'terkk$pkt/NESTO_PKZ',
        // naziv: '? NESTO',
        kolicina: 1,
      };
      // _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
      _arr.push(item);
      // const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }
    //
    // 2. P1
    if (true) { // 2. Odnosi se na element poluproizvoda(sklopa)
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pkz/P1',
        identmaterijala: pkz_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }
    // 3. P2
    if (true) { // 3. Odnosi se na element poluproizvoda(sklopa)
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pkz/P2',
        identmaterijala: pkz_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }
    // 4. P3
    if (true) { // 4. Odnosi se na element poluproizvoda(sklopa)
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pkz/P3',
        identmaterijala: pkz_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }
    // 5. P4
    if (true) { // 5. Odnosi se na element poluproizvoda(sklopa)
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pkz/P4',
        identmaterijala: pkz_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }
    // 6. P5
    if (true) { // 6. Odnosi se na element poluproizvoda(sklopa)
      let item_jednodelni;
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pkz/P5',
        identmaterijala: pkz_materijal_lim,
      };
      item.kolicina = 1; // DIRTY
      item.razvijenamera1 = pkz_a; // DIRTY
      item_jednodelni = item;
      // Kod elementa P5 Ukoliko je A>1250 onda se Dim. 1 i razvijena1 dele na pola. i količina se povećava na 2.
      // PREPOLOVLJAVANJE MEHANIZAM SPECIAL gde se deljenje okida zavisno od posebnog uslova, sa prostim deljenjem na pola i dupliranjem kolicine
      // let ter_visedelni_koliko_delova = null; // NE KORISTI SE
      if (pkz_brojdelova === 2) { // PREPOLOVLJAVANJE MEHANIZAM CASE dve iste polovine
        // ter_visedelni_koliko_delova = 2; // NE KORISTI SE
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu 
        item.razvijenamera1 = _prepolovljena_duzina;
        item.kolicina = item_jednodelni.kolicina * 2; // kolicina za 2 ista dela se uduplava
        item.ter_koji_deo_visedelnog = '1/2'; //
      }
      // item.dimenzija1 = pkz_a; // DIRTY
      item.dimenzija1 = item.razvijenamera1; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_pkz);
    }

  }
  //
  //
  return {
    svasta: {},
    _arr,
    _protobomp,
  }; // TODO
};



//
const _izracunaj_multitranslator_lang = (subDraftel) => {
  // TODO
};


// ---------- VIRBOM DERIVATS ----------

